import React from "react";
import PropTypes from "prop-types";

const Progressbar = ({ size = 40, color = "primary", className = "" }) => {
    // Map common color shortcuts
    const colorClass = `text-${color}`;

    return (
        <div
            className={`inline-block animate-spin rounded-full border-2 border-current border-t-transparent ${colorClass} ${className}`}
            style={{
                width: size,
                height: size,
            }}
        />
    );
};

Progressbar.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string, // accepts Tailwind color names like "primary", "white", "green-500"
    className: PropTypes.string, // extra classes
};

export default Progressbar;
